module.exports = __webpack_public_path__ + "static/media/text_box01.992412bb.png";